export const AFFILIATE_PROGRAM_COMMISSIONS_EDIT_ROUTE_NAME = Symbol('affiliate-program.commissions.edit');

export const AFFILIATE_PROGRAM_COMMISSIONS_DELETE_URL = 'admin/conditions/:id';
export const AFFILIATE_PROGRAM_COMMISSIONS_DELETE_MUTATION_KEY = 'affiliate-program.commissions.delete';

export const AFFILIATE_PROGRAM_COMMISSIONS_SAVE_URL = 'admin/conditions/:id/change_with_nested_attributes';
export const AFFILIATE_PROGRAM_COMMISSIONS_SAVE_MUTATION_KEY = 'affiliate-program.commissions.edit';

export const AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_URL = 'admin/conditions/list_merchants';
export const AFFILIATE_PROGRAM_COMMISSIONS_MERCHANTS_LIST_QUERY_KEY = 'affiliate-program.commissions.merchants';

export const AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_URL = 'admin/conditions/list_constants';
export const AFFILIATE_PROGRAM_COMMISSIONS_CONSTANTS_QUERY_KEY = 'affiliate-program.commissions.constants';

export const AFFILIATE_PROGRAM_COMMISSIONS_ITEM_URL = 'admin/conditions/:id/edit';
export const AFFILIATE_PROGRAM_COMMISSIONS_ITEM_QUERY_KEY = 'affiliate-program.commissions.item';

export const AFFILIATE_PROGRAM_COMMISSIONS_ATTRIBUTES = [
  'for_deduction',
  'for_reward_program',
] as const;
